/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/add.json`.

import type { OperatorDefinition } from '../../definition_types';

/**
 * Add two values. In case of numeric fields, if either field is multivalued then the result is `null`.
 * For dense_vector operations, both arguments should be dense_vectors. Inequal vector dimensions generate null result.
 *
 */
const definition: OperatorDefinition = {
  operator: '+',
  name: 'add',
  signatures: [
    {
      params: [
        {
          name: 'lhs',
          type: 'date',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'date_period',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'date',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'time_duration',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'date_nanos',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'date_period',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date_nanos',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'date_nanos',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'time_duration',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date_nanos',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'date_period',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'date_period',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date_nanos',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'date_period',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'date_period',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date_period',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'dense_vector',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'dense_vector',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'dense_vector',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'dense_vector',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'double',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'double',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'double',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'double',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'integer',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'integer',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'integer',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'integer',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'long',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'long',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'long',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'long',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'time_duration',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'time_duration',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date_nanos',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'time_duration',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'time_duration',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'time_duration',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'unsigned_long',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
